<label *ngIf="!block.settings.hide_name"
       class="data-set-label">
  <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
    {{block.localizedName(currentContentLocale, originalContentLocale, true)}}
  </span>
  <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible"></pl-required-indicator>
</label>

<ng-container *ngIf="blocksConfig.editable || blocksConfig.preview">
  <pl-data-set-input-row [block]="block"></pl-data-set-input-row>
  <ng-container *ngTemplateOutlet="addButtonTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="helptext"></ng-container>
</ng-container>

<ng-container *ngIf="!blocksConfig.editable && !blocksConfig.preview">
  <div>
    <div [cdkDropListDisabled]="!blocksConfig.submittable || ineligible" cdkDropList (cdkDropListDropped)="drop($event)">
      <p *ngIf="rows.length <= 0 && !blocksConfig.preview && !blocksConfig.submittable && !blocksConfig.editable && !block.settings.hide_name"
         class="alert alert-secondary mb-0">
        {{'blocks.Block::Input::DataSetInput.validationInfo.noData' | transloco}}
      </p>

      <ng-container *ngFor="let row of rows">
        <div class="data-set-row" cdkDrag>
          <button class="drag-handle" cdkDragHandle type="button" *ngIf="blocksConfig.submittable && !ineligible" tabindex="-1">
            <img src="/assets/images/drag-handle.svg">
          </button>
          <pl-data-set-input-row [block]="block" [row_id]="row"></pl-data-set-input-row>
          <pl-data-set-input-row-delete-button
            *ngIf="blocksConfig.submittable && !ineligible"
            (deleteRow)="deleteRow(row)">
          </pl-data-set-input-row-delete-button>
        </div>
      </ng-container>
    </div>

    <div [class.mt-2]="rows.length > 0"
         class="row align-items-center">
      <div class="col col-auto">
        <ng-container *ngTemplateOutlet="addButtonTemplate"></ng-container>
      </div>
      <div class="col pl-sm-0 instructions">
        <p *ngIf="blocksConfig.submittable && (block.settings.minRows || block.settings.maxRows) && validationInfo" class="validation-info text-muted mb-0">
          {{ validationInfo }}
        </p>
        <div *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && (block.settings.minRows || block.settings.maxRows) && !!formControl?.invalid && !!formControl?.touched"
             class="text-danger mb-0">
          {{ validationError }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ng-container *ngTemplateOutlet="helptext"></ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #helptext>
  <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
         [id]="domId + slug + 'helptext'"
         [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
         class="form-text text-muted d-block mt-2"
         aria-hidden="true">
    {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
  </small>
</ng-template>

<ng-template #addButtonTemplate>
  <button *ngIf="blocksConfig.submittable && !ineligible"
          [gizmoDestinationInput]="formControl"
          [gizmoDestination]="this"
          [style.background-color]="block.styles.button_background"
          [style.color]="block.styles.button_color"
          [disabled]="data.length >= (block.settings.maxRows || Infinity)"
          (click)="!blocksConfig.editable && blocksConfig.submittable ? addNewRow() : onClickInEditor()"
          [attr.data-slug]="slug"
          type="button"
          id="{{domId + slug}}"
          class="btn add-row"
          tabindex="0">
    <fa-icon [fixedWidth]="true" [icon]="['far', 'plus']"></fa-icon>
    <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedAddButtonLabel(currentContentLocale, originalContentLocale)">
      {{block.localizedAddButtonLabel(currentContentLocale, originalContentLocale, true)}}
    </span>
  </button>
</ng-template>
